import * as P from "fp-ts-routing";
import { pipe } from "fp-ts/function";

export type AssetsRoute = {};

// export const assetsQueryMatch = P.query(AssetPageLocationModel);

export const assetsPageMatch = pipe(P.lit("assets"));
